import Link from 'next/link'
import React from 'react'
import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'
import { Layout } from '../../components/Layout'
import { SitemapLayout, SitemapItem, Wrapper, Content } from './SitemapPage.styles'

export const SitemapPage = ({
  specificPost,
}: {
  specificPost: { postTitle: string; postUrl: string }[]
}) => {
  const header = <Header />

  return (
    <Layout header={header} hideCTA>
      <Content>
        <Wrapper>
          <h1>Sitemap</h1>
          <SitemapLayout>
            <SitemapItem key="Why We Feed Raw">
              <Link href="/why-we-feed-raw" passHref>
                <a>Why We Feed Raw</a>
              </Link>
            </SitemapItem>

            <SitemapItem key="Reviews">
              <Link href="/reviews" passHref>
                <a>Reviews</a>
              </Link>
            </SitemapItem>

            <SitemapItem key="Mealplan">
              <Link href="/meal-plan/step-1" passHref>
                <a>Meal Plan</a>
              </Link>
            </SitemapItem>

            <SitemapItem key="Raw Benefits">
              <Link href="/raw-benefits" passHref>
                <a>Raw Benefits</a>
              </Link>
            </SitemapItem>

            <SitemapItem key="Raw Food Subscription">
              <Link href="/raw-food-subscription" passHref>
                <a>Raw Food Subscription</a>
              </Link>
            </SitemapItem>

            <SitemapItem key="FAQs">
              <Link href="/faqs" passHref>
                <a>FAQs</a>
              </Link>
            </SitemapItem>

            <SitemapItem key="Login">
              <Link href="/login" passHref>
                <a>Login</a>
              </Link>
            </SitemapItem>

            <SitemapItem key="Terms & Conditions">
              <Link href="/terms-and-conditions" passHref>
                <a>Terms & Conditions</a>
              </Link>
            </SitemapItem>

            <SitemapItem key="Privacy Policy">
              <Link href="/privacy-policy" passHref>
                <a>Privacy Policy</a>
              </Link>
            </SitemapItem>

            {/* category */}
            <SitemapItem key="Products">
              <Link href="/products" passHref>
                <a>Products</a>
              </Link>
            </SitemapItem>

            <SitemapItem indent="true" key="Big Box">
              <Link href="/products/big-box" passHref>
                <a>Big Box</a>
              </Link>
            </SitemapItem>

            <SitemapItem indent="true" key="Classic Box">
              <Link href="/products/classic-box" passHref>
                <a>Classic Box</a>
              </Link>
            </SitemapItem>
            <SitemapItem indent="true" key="Small Box">
              <Link href="/products/small-box" passHref>
                <a>Small Box</a>
              </Link>
            </SitemapItem>
            <SitemapItem indent="true" key="5lb Venison Patty Recipe">
              <Link href="/products/5-lb-venison-patty-recipe" passHref>
                <a>5lb Venison Patty Recipe</a>
              </Link>
            </SitemapItem>
            <SitemapItem indent="true" key="5lb Lamb Patty Recipe">
              <Link href="/products/5-lb-lamb-patty-recipe" passHref>
                <a>5lb Lamb Patty Recipe</a>
              </Link>
            </SitemapItem>
            <SitemapItem indent="true" key="5lb Duck Patty Recipe">
              <Link href="/products/5-lb-duck-patty-recipe" passHref>
                <a>5lb Duck Patty Recipe</a>
              </Link>
            </SitemapItem>
            <SitemapItem indent="true" key="5lb Turkey Patty Recipe">
              <Link href="/products/5-lb-turkey-patty-recipe" passHref>
                <a>5lb Turkey Patty Recipe</a>
              </Link>
            </SitemapItem>
            <SitemapItem indent="true" key="5lb Beef Patty Recipe">
              <Link href="/products/5-lb-beef-patty-recipe" passHref>
                <a>5lb Beef Patty Recipe</a>
              </Link>
            </SitemapItem>
            <SitemapItem indent="true" key="5lb Chicken Patty Recipe">
              <Link href="/products/5-lb-chicken-patty-recipe" passHref>
                <a>5lb Chicken Patty Recipe</a>
              </Link>
            </SitemapItem>

            {/* category */}
            <SitemapItem key="Blog">
              <Link href="/blog" passHref>
                <a>Blog</a>
              </Link>
            </SitemapItem>

            {specificPost.map((post) => {
              return (
                <SitemapItem indent="true" key={post.postTitle}>
                  <Link href={`/blog/${post.postUrl}`} passHref>
                    <a>{post.postTitle}</a>
                  </Link>
                </SitemapItem>
              )
            })}
          </SitemapLayout>
        </Wrapper>
      </Content>
      <Footer />
    </Layout>
  )
}

SitemapPage.displayName = 'SitemapPage'
